import React from "react";

interface Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  icon?: React.ElementType;
  error?: string;
}

const TextAreaField = ({ label, icon: Icon, required = false, error, ...props }: Props) => (
  <div>
    <label className="flex items-center text-sm font-medium text-gray-700 mb-2">
      {Icon && <Icon size={16} className="me-2 text-[#b3d130]" />}
      {label} {required && <span className="text-red-500 ms-1">*</span>}
    </label>
    <textarea
      {...props}
      rows={4}
      className={`w-full px-4 py-3 border rounded-xl focus:border-[#b3d130] focus:outline-none focus:ring-2 focus:ring-[#b3d130]/20 transition-all duration-300 resize-none ${error ? "border-red-500 bg-red-50" : "border-gray-300"}`}
    />
    {error && (
      <p className="text-xs text-red-500 mt-1 flex items-center gap-1">
        <span className="text-red-500">⚠️</span>
        {error}
      </p>
    )}
  </div>
);

export default TextAreaField;
